import React from "react";
import { SpinnerContainer, LogoAndBarContainer, Logo, LoadingCircle, BlinkingText } from "./index";

function Loading() {
  return (
    <SpinnerContainer>
      <LogoAndBarContainer>
        {/* Logo and Circular Loading Bar */}
        <Logo />
        <LoadingCircle />
      </LogoAndBarContainer>

      {/* Blinking Text */}
      <BlinkingText>
        Today Local No.1 News App in India
      </BlinkingText>
    </SpinnerContainer>
  );
}

export default Loading;
